/** Generic Reducer actions */
export const SET_LOADING = 'SET_LOADING';
export const SET_ERROR = 'SET_ERROR';
export const STORE_DATA = 'STORE_DATA';
export const UPDATE_DATA = 'UPDATE_DATA';
export const CLEAR_DATA = 'CLEAR_DATA';
export const SET_LOADING_PROGRESS = 'SET_LOADING_PROGRESS';

/** Special Actions */
export const STORE_MODIFIER_AGGREGATION = 'STORE_MODIFIER_AGGREGATION';
export const SET_ACTIVE_TAB = 'SET_ACTIVE_TAB';
export const STORE_TREE_DATA = 'STORE_TREE_DATA';
export const RESET = 'RESET';
export const SET_QUANTITY = 'SET_QUANTITY';

/** Reducer stores */
export const MENU_ITEMS = 'MENU_ITEMS';
export const MENU_MODIFIERS = 'MENU_MODIFIERS';
export const POS_ITEMS = 'POS_ITEMS';
export const POS_MODIFIERS = 'POS_MODIFIERS';
export const SYNCHRONIZATION = 'SYNCHRONIZATION';

export const SELECT_POS_MAPPING = 'SELECT_POS_MAPPING';

export const TO_SELECTED = 'toSelected';
export const IGNORE = 'ignore';
export const INSTRUCTION = 'instruction';

// pos ids
export const PASS = 'PASS';
export const INSTRUCTION_ABBREVIATED = 'INS';
export const CUSTOMER_REVIEW = 'CUSTOMER_REVIEW';

export const MENU_MODIFIERS_LIMIT = 3000;

export const IS_ADDITION = 'is_addition';
export const IS_MAIN = 'is_main';
export const MODIFIER = 'modifier';

export const MODIFIERS_LABEL = 'Modifiers';
export const MAIN_ITEMS_LABEL = 'Main Items';

export const SET_MAIN = 'setmain';
export const SET_ADDITION = 'setaddition';
export const CLEAR = 'clear';

/** *************************** MENU MANAGEMENT MAPPING *********************************** */

export const MAX_MAPPING_TEXT_LENGTH = 75;
export const NAME_OBJECT_KEY = 'name';
export const MAPPING_STATUS_COLUMN = 'mappingStatus';
export const AS_ADDITION = 'asAddition';
export const AS_INSTRUCTION = 'asInstruction';
export const REPLACES_MAIN = 'replacesMain';
export const DEFAULT = 'default';
export const IS_NESTED_MODIFIER = 'isNestedModifier';
export const GRANDPARENT_NAMES = 'grandparentNames';
export const MAIN_ITEMS = 'mainItems';
export const GRANDPARENT_UUIDS = 'grandparentUuids';
export const MODIFIER_GROUP = 'modifierGroup';
export const CATEGORY = 'category';
export const PARENT_NAMES = 'parentNames';
export const CONFIDENCE = 'confidence';
export const PRICE = 'price';
export const DEFAULT_MODIFIERS = 'defaultModifiers';
export const UUID_EXTERNAL_ID = 'uuidExternalId';
export const UUID_NAME = 'uuidName';
export const SHOW_DEFAULT_MODIFIERS = 'showDefaultModifiers';
export const EXTERNAL_ID_MAPPING = 'externalIdMapping';
export const UNMAPPED_TEXT = 'Unmapped, select an item';
export const AS_ADDITION_MESSAGE =
  'Maps an App Modifier to a POS Main Item and adds to the order as a Main Item';
export const AS_INSTRUCTION_MESSAGE =
  'Item/Modifier is added as an instruction (no item ID is mapped or sent to the POS)';
export const REPLACES_MAIN_MESSAGE =
  'Modifier & Main Item in the order are replaced by the selected Main Item when sent to the POS';
export const IS_NESTED_MODIFIER_MESSAGE =
  'Some instances of this Modifier are nested (modifier of a modifier)';
export const IGNORE_MESSAGE =
  'This Item/Modifier will not be sent to the POS, it will be removed from the order';
export const MAIN_REQUIRED_TEXT = 'All parent items are required to be mapped';
export const POS_ID_NOT_REQUIRED = 'POS ID not required; set to add as instruction / ignore';

export const MAPPING_STATUS = {
  UNMAPPED: 'unmapped',
  MAPPED: 'mapped',
  STAGED_MAPPED: 'staged-mapped',
  STAGED_UNMAPPED: 'staged-unmapped',
  STAGED: 'staged',
  POS_MISSING: 'pos-missing',
};

export const FLAG_BADGE = {
  AS_ADDITION: 'Additional',
  AS_INSTRUCTION: 'Instruction',
  IGNORE: 'Ignore',
  REPLACES_MAIN: 'Replace',
};

export const MAPPING_BADGE = {
  EDITED_MAPPED: 'EDITED_MAPPED',
  EDITED_UNMAPPED: 'EDITED_UNMAPPED',
  MAPPED: 'MAPPED',
  UNMAPPED: 'UNMAPPED',
};

export const MAPPING_BADGE_LABEL = {
  EDITED: 'Edited',
  MAPPED: 'Mapped',
  UNMAPPED: 'Unmapped',
  POS_MISSING: 'Invalid POS ID',
};

export const MAPPING_DESCRIPTION = {
  EDITED_MAPPED: 'This item is mapped to a POS item, but has not been saved.',
  EDITED_UNMAPPED: 'This item is unmapped and has not been saved.',
  MAPPED: 'This item is mapped to a POS item and saved.',
  UNMAPPED: 'The item is unmapped and saved.',
};

export const POS_MISSING_DESCRIPTION = 'Mapped POS ID does not exist';
export const formatMissingPosId = posId => {
  if (!posId) return POS_MISSING_DESCRIPTION;
  return `${POS_MISSING_DESCRIPTION} [${posId}]`;
};

export const POST_TAG = {
  MAPPED: '[mapped]',
  MULTIPLE: '[mapped to multiple]',
  UNMAPPED: '[unmapped]',
};

export const MAPPING_FILTERS = {
  STATUS: 'Statuses',
  CATEGORY: 'Categories',
  MOD_GROUP: 'Mod groups',
  PARENT: 'Parents',
};
